import { defineStore } from 'pinia'
import { ref } from 'vue'
import User from '@/models/User'

/**
 * Store for the "upgrade required" modal. Used by v-require-paid (feature-gated) directive.
 * @param { { featureKey?: string, requiredPlan?: string } } [options]
 */
export const usePaidFeatureStore = defineStore('paidFeature', () => {
  const visible = ref(false)
  /** @type {import('vue').Ref<string|undefined>} */
  const featureKey = ref(undefined)
  /** @type {import('vue').Ref<string|undefined>} */
  const requiredPlan = ref(undefined)

  function open(options = {}) {
    featureKey.value = options.featureKey
    requiredPlan.value = options.requiredPlan ?? (options.featureKey ? User.requiredPlanForFeature(options.featureKey) : undefined)
    visible.value = true
  }

  function close() {
    visible.value = false
    featureKey.value = undefined
    requiredPlan.value = undefined
  }

  return {
    visible,
    featureKey,
    requiredPlan,
    open,
    close,
  }
})
